module.exports = __webpack_public_path__ + "img/canvas-day-cool.0b84cdcc.jpg";